import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { JobQueryParams, PaginatedJobErrorResponse } from '@frontend/import/types';

export class JobErrorClient extends APIClient {
    public static readonly endpoint = '/import-api/v1';

    public static async fetchJobErrors(queryParams?: ApiQueryParams<JobQueryParams>): Promise<PaginatedJobErrorResponse> {
        return await this.apiPaginated<PaginatedJobErrorResponse, DefaultQueryParams>(`${this.endpoint}/errors`, queryParams);
    }

    public static async resolveJobErrors(jobIds: string[]): Promise<PaginatedJobErrorResponse> {
        const response = await this.post(`${this.endpoint}/errors-resolve`, { ids: jobIds });
        return await this.handleResponse<PaginatedJobErrorResponse>(response);
    }
}
